import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Set browser title
document.title = environment.appTitle;
 
// Set favicon
const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (favicon) {
  favicon.href = environment.appFavicon;
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
